import React, { useContext, useEffect, useState, useMemo } from "react";
import Dialog from "@mui/material/Dialog";
import {
  Avatar,
  Box,
  IconButton,
  Typography,
  Slide,
  InputBase,
  Chip,
  alpha,
} from "@mui/material";
import { Close, Search, Business, CheckCircle } from "@mui/icons-material";
import AuthContext from "../../../Context/Auth/AuthContext";
import clienteAxios from "../../../config/axios";
import ConfirmacionDialog from "../../../views/components/ConfirmacionDialog";
import { withRouter } from "react-router-dom";
import MenuContext from "../../../Context/Menu/MenuContext";
import { Cancel, ChangeCircle } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogEmpresas = ({ open, setopen, history }) => {
  const { usuario, iniciarSesion, usuarioAutenticado } = useContext(
    AuthContext,
  );
  const { obtenerCategorias } = useContext(MenuContext);

  const [empresasData, setempresasData] = useState([]);
  const [nuevaEmpresa, setnuevaEmpresa] = useState("");
  const [openConfirm, setopenConfirm] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (!open) return;
    const getempresasData = async () => {
      setCargando(true);
      try {
        const res = await clienteAxios.post("empresas/logos-por-codigos", {
          mis_empresas: usuario.mis_empresas,
        });

        console.log({ res });
        setempresasData(res.data || []);
      } catch (error) {
        console.log({ error });
        setempresasData([]);
      } finally {
        setCargando(false);
      }
    };
    getempresasData();
  }, [usuario.mis_empresas, open]);

  const empresasFiltradas = useMemo(() => {
    if (!busqueda.trim()) return empresasData;
    const term = busqueda.toLowerCase();
    return empresasData.filter(
      (e) =>
        e.empCodigo?.toLowerCase().includes(term) ||
        e.empNombre?.toLowerCase().includes(term),
    );
  }, [empresasData, busqueda]);

  const handleChangeEmpresa = async () => {
    await iniciarSesion({
      usuario: usuario.usuario,
      sinpassword: true,
      password: "",
      empresa: nuevaEmpresa,
      from: "web",
    });
    await usuarioAutenticado();
    await setopenConfirm(false);
    obtenerCategorias();
    setopen(false);
    window.location.reload();
  };

  const handleSeleccionar = (codigo) => {
    if (codigo === usuario.rucempresa) return;
    setnuevaEmpresa(codigo);
    setopenConfirm(true);
  };

  return (
    <>
      <ConfirmacionDialog
        open={openConfirm}
        setopen={setopenConfirm}
        categoria="warning"
        titulo={`¿Esta seguro de cambiar a la empresa: ${nuevaEmpresa}?`}
        botones={[
          {
            tooltip: "Se cambiará de empresa",
            texto: "SI",
            funcion: () => handleChangeEmpresa(),
            disabled: false,
            Icon: ChangeCircle,
            color: "success",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => setopenConfirm(false),
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <Dialog
        open={open}
        onClose={() => {
          setopen(false);
          setnuevaEmpresa("");
          setBusqueda("");
        }}
        TransitionComponent={Transition}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxHeight: "80vh",
          },
        }}
      >
        <Box
          sx={{
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{
                color: "common.white",
                fontWeight: 700,
                letterSpacing: "0.02em",
              }}
            >
              Mis Empresas
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: (theme) =>
                  alpha(theme.palette.primary.contrastText, 0.6),
              }}
            >
              Selecciona una empresa para continuar
            </Typography>
          </Box>
          <IconButton
            onClick={() => {
              setopen(false);
              setnuevaEmpresa("");
              setBusqueda("");
            }}
            sx={{
              color: (theme) => alpha(theme.palette.primary.contrastText, 0.7),
              "&:hover": { color: "common.white" },
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {empresasData.length > 5 && (
          <Box
            sx={{
              px: 3,
              pt: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.05),
                borderRadius: 2,
                px: 2,
                py: 0.5,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Search sx={{ color: "text.secondary", fontSize: 20, mr: 1 }} />
              <InputBase
                placeholder="Buscar empresa..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                sx={{ flex: 1, fontSize: "0.9rem" }}
                autoFocus
              />
              {busqueda && (
                <IconButton size="small" onClick={() => setBusqueda("")}>
                  <Close sx={{ fontSize: 16 }} />
                </IconButton>
              )}
            </Box>
          </Box>
        )}

        <Box
          sx={{
            px: 3,
            py: 2,
            overflow: "auto",
            flex: 1,
          }}
        >
          {empresasFiltradas.length === 0 && !cargando && (
            <Box
              sx={{
                py: 6,
                textAlign: "center",
              }}
            >
              <Business sx={{ fontSize: 48, color: "text.disabled", mb: 1 }} />
              <Typography variant="body2" color="text.secondary">
                {busqueda
                  ? "No se encontraron empresas"
                  : "No hay empresas disponibles"}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
              },
              gap: 1.5,
            }}
          >
            {empresasFiltradas.map((empresa) => {
              const esActual = empresa.empCodigo === usuario.rucempresa;
              return (
                <Box
                  key={empresa.empCodigo}
                  onClick={() => handleSeleccionar(empresa.empCodigo)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 1.5,
                    borderRadius: 2,
                    cursor: esActual ? "default" : "pointer",
                    border: "1px solid",
                    borderColor: esActual
                      ? (theme) => alpha(theme.palette.primary.main, 0.25)
                      : "divider",
                    bgcolor: esActual
                      ? (theme) => alpha(theme.palette.primary.main, 0.06)
                      : "transparent",
                    position: "relative",
                    transition: "all 0.2s ease",
                    "&:hover": esActual
                      ? {}
                      : {
                          bgcolor: (theme) =>
                            alpha(theme.palette.primary.main, 0.04),
                          borderColor: (theme) =>
                            alpha(theme.palette.primary.main, 0.2),
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                        },
                  }}
                >
                  <Avatar
                    src={empresa.empLogo}
                    sx={{
                      width: 42,
                      height: 42,
                      bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, 0.1),
                      color: "primary.main",
                      fontWeight: 600,
                      fontSize: "0.9rem",
                      border: esActual
                        ? (theme) => `2px solid ${theme.palette.primary.main}`
                        : "2px solid transparent",
                    }}
                  >
                    {(empresa.empCodigo || "?").charAt(0).toUpperCase()}
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      fontWeight={esActual ? 700 : 600}
                      noWrap
                      sx={{
                        color: esActual ? "primary.main" : "text.primary",
                      }}
                    >
                      {empresa.empCodigo}
                    </Typography>
                    {empresa.empNombre && (
                      <Typography
                        variant="caption"
                        noWrap
                        sx={{ color: "text.secondary", display: "block" }}
                      >
                        {empresa.empNombre}
                      </Typography>
                    )}
                  </Box>
                  {esActual && (
                    <Chip
                      icon={
                        <CheckCircle sx={{ fontSize: "0.85rem !important" }} />
                      }
                      label="Activa"
                      size="small"
                      color="primary"
                      sx={{
                        height: 24,
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        "& .MuiChip-icon": { fontSize: "0.85rem" },
                      }}
                    />
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>

        <Box
          sx={{
            px: 3,
            py: 1.5,
            borderTop: "1px solid",
            borderColor: "divider",
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.02),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {empresasFiltradas.length} empresa
            {empresasFiltradas.length !== 1 ? "s" : ""}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Actual: <strong>{usuario.rucempresa}</strong>
          </Typography>
        </Box>
      </Dialog>
    </>
  );
};

export default withRouter(DialogEmpresas);
